import { FC } from 'react'
import { WrappedFieldProps, WrappedFieldInputProps } from 'redux-form'
import Checkbox, { LabelCheckboxProps } from 'components/atoms/inputs/Checkbox'
import { State } from 'interfaces/state'
import { QAMarked } from 'interfaces/component'

type CheckboxWrappedProps =
  & WrappedFieldProps<State>
  & QAMarked
  & LabelCheckboxProps
  & {
    onValueChange?: (value: boolean) => void
  }

const CheckboxWrapped: FC<CheckboxWrappedProps> = (props) => {
  const { qaMarker, onValueChange = () => null } = props
  const input: WrappedFieldInputProps | undefined = props.input

  if (!input) {
    return null
  }

  return (
    <Checkbox
      name={ input.name }
      label={ 'label' in props ? props.label : undefined }
      labelRenderer={ 'labelRenderer' in props ? props.labelRenderer : undefined }
      checked={ input.value }
      qaMarker={ qaMarker }
      onChange={ (e) => {
        onValueChange(!input.value)
        input.onChange(e)
      } }
    />
  )
}

export default CheckboxWrapped
